<script setup>
import { computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const APPS = {
  verbacio: {
    title: 'Verbacio',
    url: 'https://voice.verbacio.us/',
    openInNewTab: false,
  },
  proofing: {
    title: 'Proofing',
    url: 'https://flow.thebannerstore.com/',
    openInNewTab: true,
  },
  cholula: {
    title: 'Ch.olu.la',
    url: 'https://ch.olu.la/admin/',
    openInNewTab: true,
  },
  'job-board': {
    title: 'Job Board',
    url: 'https://flow.thebannerstore.com/chatwoot/board?key=b95ce9af22a8c8c4d3ca1a18d0c274a0a5dde2ef43ab62df',
    openInNewTab: true,
  },
};

const route = useRoute();
const router = useRouter();
const app = computed(() => APPS[route.params.appSlug] || null);
const openedExternally = computed(() => Boolean(app.value?.openInNewTab));

onMounted(() => {
  if (!app.value?.openInNewTab) return;
  window.open(app.value.url, '_blank', 'noopener,noreferrer');
});

const goHome = () => {
  router.push({ name: 'home' });
};
</script>

<template>
  <div class="flex flex-col h-full w-full bg-n-background">
    <template v-if="app && openedExternally">
      <div class="flex flex-col items-start gap-3 p-6 max-w-xl">
        <div class="text-base font-medium text-n-slate-12">
          {{ app.title }} opened in a new tab
        </div>
        <p class="text-sm text-n-slate-11 m-0">
          If nothing opened, use the link below (pop-up blockers can interfere).
        </p>
        <a
          :href="app.url"
          target="_blank"
          rel="noopener noreferrer"
          class="text-sm text-n-brand hover:underline"
        >
          Open {{ app.title }}
        </a>
        <button
          type="button"
          class="text-sm text-n-slate-11 hover:text-n-slate-12 underline bg-transparent border-0 p-0 cursor-pointer"
          @click="goHome"
        >
          Back to conversations
        </button>
      </div>
    </template>
    <template v-else-if="app">
      <div
        class="flex items-center justify-between gap-3 px-4 py-2 border-b border-n-weak"
      >
        <div class="text-sm font-medium text-n-slate-12">{{ app.title }}</div>
        <a
          :href="app.url"
          target="_blank"
          rel="noopener noreferrer"
          class="text-xs text-n-brand hover:underline"
        >
          Open in new tab
        </a>
      </div>
      <iframe
        :src="app.url"
        :title="app.title"
        class="flex-1 w-full border-0 bg-white"
        allow="clipboard-read; clipboard-write; microphone; camera"
      />
    </template>
    <div v-else class="p-6 text-sm text-n-slate-11">Unknown app.</div>
  </div>
</template>
